import { take } from 'lodash';
import { Start } from 'api/notifications';
export const NotificationCount = (count)=>[
        'notification_count',
        count
    ];
export const FetchInfo = (count, start, notifications)=>[
        'fetch_info',
        count,
        start,
        notifications
    ];
export const Loading = (item)=>[
        'loading',
        item
    ];
export const Loaded = (item)=>[
        'loaded',
        item
    ];
export const Deleted = (item)=>[
        'deleted',
        item
    ];
export const Empty = [
    'empty'
];
export const FetchingFirstPage = (count, moment)=>[
        'fetching_first_page',
        count,
        moment
    ];
export const Fetched = (info, previous, current, moment, loadMore)=>{
    const count = info[1][1];
    const actual = previous.concat(take(current, count));
    const next = current[count][1].notifications[0].sortKey;
    return [
        'fetched',
        info,
        actual,
        moment,
        loadMore(info, Start(next))
    ];
};
export const Fetching = (info, groups, moment)=>[
        'fetching',
        info,
        groups,
        moment
    ];
export const FetchedLastPage = (info, groups, moment)=>[
        'fetched_last_page',
        info,
        groups,
        moment
    ];
export const setGroups = ([kind, info, , requestedAt, loadMore], groups)=>[
        kind,
        info,
        groups,
        requestedAt,
        loadMore
    ];
export const PendingUpdatesCount = (count)=>[
        'pending_updates_count',
        count
    ];
